import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["target", "view", "href"];
function _createForOfIteratorHelper(o, allowArrayLike) {
  var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
  if (!it) {
    if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
      if (it) o = it;
      var i = 0;
      var F = function F() {};
      return {
        s: F,
        n: function n() {
          if (i >= o.length) return {
            done: true
          };
          return {
            done: false,
            value: o[i++]
          };
        },
        e: function e(_e) {
          throw _e;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var normalCompletion = true,
    didErr = false,
    err;
  return {
    s: function s() {
      it = it.call(o);
    },
    n: function n() {
      var step = it.next();
      normalCompletion = step.done;
      return step;
    },
    e: function e(_e2) {
      didErr = true;
      err = _e2;
    },
    f: function f() {
      try {
        if (!normalCompletion && it.return != null) it.return();
      } finally {
        if (didErr) throw err;
      }
    }
  };
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
import Abstract from '../abstract';
import { defineComponent, resolveComponent, openBlock, createElementBlock, normalizeClass, renderSlot, createBlock, mergeProps, withCtx } from 'vue';
var _sfc_main = defineComponent({
  name: 'StepinLink',
  extends: Abstract,
  props: {
    to: {
      type: [String, Object],
      required: true
    },
    replace: Boolean,
    activeClass: String,
    exactActiveClass: String,
    custom: Boolean,
    ariaCurrentValue: {
      type: String,
      default: 'page'
    },
    target: String,
    view: {
      type: String,
      required: false
    },
    href: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      className: 'link'
    };
  },
  computed: {
    sHref: function sHref() {
      var _router$resolve;
      var to = this.to,
        href = this.href,
        router = this.$router,
        resolveTo = this.resolveTo;
      return href !== null && href !== void 0 ? href : router === null || router === void 0 ? void 0 : (_router$resolve = router.resolve(resolveTo)) === null || _router$resolve === void 0 ? void 0 : _router$resolve.href;
    },
    linkProps: function linkProps() {
      var _this$$props = this.$props,
        target = _this$$props.target,
        view = _this$$props.view,
        href = _this$$props.href,
        otherProps = _objectWithoutProperties(_this$$props, _excluded);
      var linkProps = _objectSpread({}, otherProps);
      linkProps.to = this.resolveTo;
      return linkProps;
    },
    resolveTo: function resolveTo() {
      var to = this.to,
        view = this.view;
      if (view && to) {
        return typeof to === 'string' ? {
          path: to,
          query: {
            _to_view: view
          }
        } : _objectSpread(_objectSpread({}, to), {}, {
          query: _objectSpread(_objectSpread({}, to.query), {}, {
            _to_view: view
          })
        });
      }
      return to;
    }
  }
});
var _export_sfc = function _export_sfc(sfc, props) {
  var target = sfc.__vccOpts || sfc;
  var _iterator = _createForOfIteratorHelper(props),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _step$value = _slicedToArray(_step.value, 2),
        key = _step$value[0],
        val = _step$value[1];
      target[key] = val;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  return target;
};
var _hoisted_1 = ["href"];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_router_link = resolveComponent("router-link");
  return _ctx.target === "_blank" ? (openBlock(), createElementBlock("a", {
    key: 0,
    class: normalizeClass(_ctx.prefixCls),
    href: _ctx.sHref,
    target: "_blank"
  }, [renderSlot(_ctx.$slots, "default")], 10, _hoisted_1)) : (openBlock(), createBlock(_component_router_link, mergeProps({
    key: 1,
    class: _ctx.prefixCls
  }, _ctx.linkProps), {
    default: withCtx(function () {
      return [renderSlot(_ctx.$slots, "default")];
    }),
    _: 3
    /* FORWARDED */
  }, 16, ["class"]));
}
var StepinLink = /* @__PURE__ */_export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/chenghongxing/VsCodeProjects/stepin/components/stepin-link/StepinLink.js"]]);
export { StepinLink as default };